const PREFIX = "gp_modal_draft:";
const DRAFT_VERSION = 4;
const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;

function userPart() {
  return localStorage.getItem("user") || "anon";
}

export function draftStorageKey(identity) {
  return PREFIX + userPart() + ":" + identity;
}

export function readDraft(identity) {
  try {
    const raw = localStorage.getItem(draftStorageKey(identity));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !parsed.savedAt || parsed.v !== DRAFT_VERSION) return null;
    if (Date.now() - parsed.savedAt > MAX_AGE_MS) {
      localStorage.removeItem(draftStorageKey(identity));
      return null;
    }
    return parsed;
  } catch (e) {
    return null;
  }
}

export function writeDraft(identity, payload) {
  try {
    const data = JSON.stringify({ ...payload, savedAt: Date.now(), v: DRAFT_VERSION });
    if (data.length > 400000) return;
    localStorage.setItem(draftStorageKey(identity), data);
  } catch (e) {}
}

export function clearDraft(identity) {
  try {
    localStorage.removeItem(draftStorageKey(identity));
  } catch (e) {}
}

export function clearDraftByKey(storageKey) {
  try {
    localStorage.removeItem(storageKey);
  } catch (e) {}
}

export function clearDraftsOnSuccessfulSave(pathname, identities) {
  const ids = new Set(identities || []);
  ids.forEach((id) => {
    if (id) clearDraft(id);
  });
  const needle = PREFIX + userPart() + ":" + pathname + "::";
  const keys = [];
  for (let i = 0; i < localStorage.length; i++) {
    const k = localStorage.key(i);
    if (k && k.startsWith(needle) && /Create |Add |Possible Duplicates/i.test(k)) {
      keys.push(k);
    }
  }
  keys.forEach(clearDraftByKey);
}

function hasValue(val) {
  if (val == null) return false;
  return String(val).trim() !== "";
}

export function isEmptyDraft(draft) {
  if (!draft) return true;
  const fields = draft.fields || [];
  const hasField = fields.some((f) => {
    if (f.type === "checkbox" || f.type === "radio") return !!f.checked;
    return hasValue(f.value);
  });
  const hasAc = (draft.autocompletes || []).some((a) => hasValue(a.value));
  const hasDate = (draft.dates || []).some((d) => (d.values || []).some(hasValue));
  const hasSelect = (draft.reactSelects || []).some((s) => (s.values || []).some(hasValue));
  const hasTiny = Object.values(draft.tinymce || {}).some(
    (html) => String(html || "").replace(/<[^>]*>/g, "").trim() !== ""
  );
  return !hasField && !hasAc && !hasDate && !hasSelect && !hasTiny;
}
